<div class="row">
  <div class="col-12 mb-2">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      class="table table-striped mb-0"
    >
      <thead>
        <tr>
          <th style="width: 5px">Id</th>
          <th style="width: 80px">Changed On</th>
          <th style="width: 120px">Changed By</th>
          <th style="width: 50px">Source</th>
          <th>Shop name</th>
          <th style="width: 125px">Slip header</th>
          <th style="width: 125px">Slip trailer</th>
          <th>Card set</th>
          <th style="width: 50px">Merchant Type</th>
          <th style="width: 50px">Region Code</th>
          <th>City</th>
          <th>Town</th>
          <th style="width: 50px">Country code</th>
          <th style="width: 50px">Postal code</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let merchant of merchantDetails">
          <td style="font-size: 12px">{{ merchant.id }}</td>
          <td style="font-size: 12px">
            {{ merchant.changedOn | date: "MMMM d, y, h:mm:ss a" }}
          </td>
          <td style="font-size: 12px">{{ merchant.changedBy }}</td>
          <td style="font-size: 12px">{{ merchant.source }}</td>
          <td style="font-size: 12px">{{ merchant.shopName }}</td>
          <td style="font-size: 12px">{{ merchant.slipHeader }}</td>
          <td style="font-size: 12px">{{ merchant.slipTrailer }}</td>
          <td style="font-size: 12px">{{ merchant.cardSet }}</td>
          <td style="font-size: 12px">{{ merchant.merchantType }}</td>
          <td style="font-size: 12px">{{ merchant.regionCode }}</td>
          <td style="font-size: 12px">{{ merchant.city }}</td>
          <td style="font-size: 12px">{{ merchant.town }}</td>
          <td style="font-size: 12px">{{ merchant.countryCode }}</td>
          <td style="font-size: 12px">{{ merchant.postalCode }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="page-title-box">
      <div class="page-title-right">
        <input
          type="button"
          value="Print"
          class="btn btn-success"
          (click)="print()"
        />
        &nbsp;
        <input
          type="button"
          value="Export to CSV"
          class="btn btn-success"
          (click)="DownloadCsv()"
        />
      </div>
    </div>
  </div>
</div>
